export const enum StockTransfersTab {
    ACTIVE = 'one',
    ARCHIVED = 'two'
  }